import {getColorFromValue} from './getDefaultBucketColors';
export function recalculateSemanticLegendBuckets(
  numberOfBuckets: number,
  metricStatistics: Record<string, {min: number; max: number}>,
  yValue: string
) {
  if (!metricStatistics || !(yValue in metricStatistics)) {
    return [];
  }

  const min = safeNumber(metricStatistics[yValue].min);
  const max = safeNumber(metricStatistics[yValue].max);
  const range = safeNumber(Math.abs(max - min));
  const bucketSize = range / numberOfBuckets;
  const newBuckets = Array.from({length: numberOfBuckets}, (_, i) => ({
    bucketMin: parseFloat((min + i * bucketSize).toFixed(6)),
    bucketMax: parseFloat((min + (i + 1) * bucketSize).toFixed(6)),
    color: getColorFromValue(i, numberOfBuckets),
  }));
  return newBuckets;
}

function safeNumber(value: number) {
  if (Number.isFinite(value)) {
    return value;
  }
  if (value < Number.MIN_VALUE) {
    return Number.MIN_VALUE;
  }
  if (value > Number.MAX_VALUE) {
    return Number.MAX_VALUE;
  }
  return 0;
}
